export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "gallery" */ 'components/bolt/gallery/gallery'), component: 'gallery', parent: 'boltHome' },
	{ id: 'downloads', getter: () => import(/* webpackChunkName: "imageTiles" */ 'components/bolt/imageTiles/imageTiles'), component: 'imageTiles', parent: 'boltHome' }
];
